export default function Footer() {
  return (
    <>
      <div className="flex flex-wrap justify-center gap-3 mt-10 text-center">
        <div>
          <p className="text-sm text-gray-500">According to a survey, private sector employees make up 65% of those who take out personal loans for travel.</p>
        </div>
        <div>
          <p className="text-sm text-gray-500">A popular reason for taking a personal loan is to pay off existing, high-interest debt, such as credit card bills.</p>
        </div>
        <div>
          <p className="text-sm text-gray-500">A good credit score (typically 750 or higher) is crucial for securing a personal loan and can help you get a better interest rate.</p>
        </div>
        <div>
          <p className="text-sm text-gray-500">Personal loans are generally unsecured, meaning you don't need to put up any collateral like a house or a car to get the loan.</p>
        </div>
        <div>
          <p className="text-sm text-gray-500">Banks often use a "debt-to-income ratio" to calculate eligibility. It's generally advised that your total monthly loan payments (including the new one) should not exceed 40% of your net monthly income.</p>
        </div>
        <div>
          <p className="text-sm text-gray-500">The typical age requirement for a personal loan in India is between 21 and 55 years.</p>
        </div>
      </div>
      <div className="flex flex-wrap justify-center gap-8 mt-10 text-center">
      </div> 
    </>
  );
}
